export default __webpack_public_path__ + "2729bb8435afa2dee2a59ddf600a85bc.jpg";